import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import Intro from "./Components/Intro/Intro";
import Features from "./Components/Features/Features";
import Hobbies from "./Components/Hobbies/Hobbies";
import Title from "./Components/Title/Title";
import Footer from "./Components/Footer/Footer";
import AboutUs from "./Components/Aboutus/Aboutus";
import Pricing from "./Components/Pricing/Pricing";
import Faq from "./Components/Faq/Faq";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Title />
                <Intro />
                <Features />
                <Hobbies />
              </>
            }
          />
          <Route path="/Home" element={<Navbar />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/title" element={<Title />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/Features" element={<Features />} />
          <Route path="/Pricing" element={<Pricing />} />
          <Route path="/Hobbies" element={<Hobbies />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
